/* ============================================================
   LOOKBOOK - INDEX
   ------------------------------------------------------------
   1. --lb-dispo : hauteur reellement disponible entre l'en-tete
      et le pied de page. C'est elle qui dimensionne les
      couvertures, pour que tout tienne sur un ecran sans
      defilement (pied de page compris).
   2. Animation d'ouverture : les couvertures partent empilees
      les unes derriere les autres puis se rangent en ligne.
      Tout le deplacement est en CSS (.lookbook--stacked) : ici
      on ne fait que poser puis retirer la classe.
   3. Bouton ALL LOOKBOOK : ouverture en douceur. max-height est
      calculee au moment du clic (et non figee dans le CSS) pour
      que la transition ait une valeur a animer, quel que soit le
      nombre de series.
   4. Etagere et liste sont liees par data-lookbook-index :
      survoler une ligne souleve la tranche correspondante, et
      inversement.
   ============================================================ */
(function () {
  'use strict';

  if (window.lookbookInstalled) return;
  window.lookbookInstalled = true;

  var SEL_RACINE = '[data-lookbook]';

  /* ---------- 1. Hauteur disponible ----------------------- */
  function mesurer() {
    var racine = document.querySelector(SEL_RACINE);
    if (!racine) return;

    var entete = document.querySelector('.header-wrapper') || document.querySelector('header');
    var pied = document.querySelector('.footer') || document.querySelector('footer');
    var pris = (entete ? entete.offsetHeight : 0) + (pied ? pied.offsetHeight : 0);

    racine.style.setProperty(
      '--lb-dispo',
      Math.max(300, window.innerHeight - pris) + 'px'
    );

    mesurerLegendes(racine);
  }

  /* Hauteur reelle de chaque legende, posee sur elle.
     Le CSS replie la legende en animant max-height ; sans la vraie
     hauteur il faut mettre une valeur haute au pif, et l'animation
     se termine alors a mi-chemin (la hauteur visible sature). On
     mesure donc, et le repli devient exact. */
  function mesurerLegendes(racine) {
    var legendes = racine.querySelectorAll('.lookbook__cover-caption');
    for (var i = 0; i < legendes.length; i++) {
      var legende = legendes[i];
      var h = legende.scrollHeight;
      if (!h) continue;

      /* ON COUPE LA TRANSITION LE TEMPS DE POSER LA VALEUR.
         Sans cela, max-height passe de son repli (8rem) a la hauteur
         mesuree, et le navigateur ANIME ce changement : les legendes
         se tassaient sous les yeux du visiteur au chargement de la
         page. C'est un reglage, pas un mouvement. */
      var memoire = legende.style.transition;
      legende.style.transition = 'none';
      legende.style.setProperty('--lb-cap-h', h + 'px');
      void legende.offsetHeight;
      legende.style.transition = memoire;
    }
  }

  /* ---------- 2. Depliage de la pile ---------------------- */
  function deplier() {
    var racine = document.querySelector(SEL_RACINE);
    var etagere = racine && racine.querySelector('[data-lookbook-shelf]');
    if (!racine || !etagere) return;

    if (etagere.querySelectorAll('.lookbook__cover').length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Sur mobile l'etagere defile horizontalement, et l'animation de
       pile projette les couvertures hors du cadre vers la gauche : le
       navigateur en profite pour recaler le defilement, et l'etagere
       se retrouve de travers. On s'en passe sur petit ecran, ou on
       n'en voit de toute facon qu'une couverture et demie. */
    if (window.innerWidth <= 749) return;

    racine.classList.add('lookbook--stacked');
    /* Force le navigateur a peindre l'etat empile avant de le retirer,
       sinon il n'y a aucune transition a animer. */
    void etagere.offsetWidth;

    setTimeout(function () {
      racine.classList.remove('lookbook--stacked');
    }, 80);
  }

  /* Remise de l'etagere a son debut.
     Changer la largeur des couvertures (vue tranche) ou revenir sur
     la page laisse le navigateur avec un defilement herite qui ne
     correspond plus a rien : les couvertures apparaissent decalees
     vers la droite. On le remet a zero explicitement. */
  function recalerEtagere(doux) {
    var racine = document.querySelector(SEL_RACINE);
    var etagere = racine && racine.querySelector('[data-lookbook-shelf]');
    if (!etagere || !etagere.scrollLeft) return;
    if (doux && etagere.scrollTo) {
      try {
        etagere.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      } catch (e) {}
    }
    etagere.scrollLeft = 0;
  }

  /* ---------- 3. ALL LOOKBOOK ----------------------------- */
  function basculer(bouton) {
    var racine = bouton.closest(SEL_RACINE);
    if (!racine) return;

    var liste = racine.querySelector('[data-lookbook-all-list]');
    if (!liste) return;

    var ouvert = bouton.getAttribute('aria-expanded') === 'true';
    var contenu = liste.querySelector('.lookbook__all-inner');

    bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');

    /* Les couvertures passent sur la tranche et se resserrent :
       l'ensemble continue de tenir dans un ecran. */
    racine.classList.toggle('lookbook--liste-ouverte', !ouvert);
    liste.classList.toggle('lookbook__all--ouvert', !ouvert);

    if (ouvert) {
      liste.style.maxHeight = '0px';
    } else {
      liste.style.maxHeight = (contenu ? contenu.offsetHeight : 400) + 'px';
    }

    /* Les couvertures changent de largeur : on recale au debut, tout
       de suite puis a la fin du mouvement (la largeur n'a pas encore
       bouge au moment du clic). */
    recalerEtagere(false);
    setTimeout(function () { recalerEtagere(false); }, 700);
  }

  /* ---------- 4. Etagere <-> liste ------------------------ */
  var viseActuelle = null;

  function viser(index) {
    /* mouseover se declenche en continu : on ne touche au DOM que
       lorsque la visee change reellement. */
    if (index === viseActuelle) return;
    viseActuelle = index;

    var racine = document.querySelector(SEL_RACINE);
    if (!racine) return;

    var cibles = racine.querySelectorAll('[data-lookbook-index]');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].classList.toggle(
        'is-vise',
        index !== null && cibles[i].dataset.lookbookIndex === index
      );
    }
    racine.classList.toggle('lookbook--visee', index !== null);
  }

  function survol(event) {
    var cible = event.target.closest && event.target.closest('[data-lookbook-index]');
    viser(cible ? cible.dataset.lookbookIndex : null);
  }

  /* ---------- Branchements ------------------------------- */
  /* Ecouteurs delegues sur document : ils survivent aux re-rendus
     de l'editeur de theme. */
  document.addEventListener('click', function (event) {
    var bouton = event.target.closest && event.target.closest('[data-lookbook-all]');
    if (bouton) basculer(bouton);
  });

  /* AU DOIGT, PAS DE VISEE. Un simple toucher declenche mouseover :
     la couverture touchee restait "visee" (les autres estompees, la
     tranche soulevee) longtemps apres que le doigt soit parti. On ne
     branche donc le survol que la ou il y a vraiment un curseur. */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', survol);

    /* Souris sortie de la fenetre : plus rien n'est vise. */
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget) viser(null);
    });
  }

  function minuteur(fn, delai) {
    var id = null;
    return function () {
      if (id) clearTimeout(id);
      id = setTimeout(fn, delai);
    };
  }

  function init() {
    mesurer();
    recalerEtagere(false);
    deplier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* RETOUR SUR LA PAGE.
     Avec le cache de navigation (bouton Retour sur mobile), la page
     est restauree telle quelle : ni DOMContentLoaded ni le script ne
     repassent, mais le navigateur restaure le defilement de
     l'etagere. D'ou des couvertures decalees a droite au retour.
     pageshow, lui, part aussi sur une page restauree. */
  window.addEventListener('pageshow', function () {
    mesurer();
    recalerEtagere(false);
  });

  /* La hauteur de la liste ouverte depend de la largeur : on la
     recalcule au redimensionnement. */
  window.addEventListener(
    'resize',
    minuteur(function () {
      mesurer();
      var liste = document.querySelector('.lookbook__all--ouvert');
      if (!liste) return;
      var contenu = liste.querySelector('.lookbook__all-inner');
      if (contenu) liste.style.maxHeight = contenu.offsetHeight + 'px';
    }, 150)
  );
})();
